import { ObstetricalFileType } from "@/Patient/Models/ObstetricalFile/Enum/ObstetricalFileType";
import { IHandleObstetricalLabResult } from "./BaseObstetricalLabResultHandler";
import { BritishColumbiaObstetricaLabResultHandler } from "./BritishColumbiaObstetricaLabResultHandler";
import { OntarioObstetricaLabResultHandler } from "./OntarioObstetricaLabResultHandler";

class ObstetricalLabResultHandlerFactory {
    public static createForType(obstetricalFileType: ObstetricalFileType): IHandleObstetricalLabResult {
        switch (obstetricalFileType) {
            case ObstetricalFileType.BritishColumbiaForm:
                return new BritishColumbiaObstetricaLabResultHandler();
            case ObstetricalFileType.OntarioForm:
                return new OntarioObstetricaLabResultHandler();
            default:
                return null;
        }
    }
}

export { ObstetricalLabResultHandlerFactory };
